import styled from '@emotion/styled'
import { metrics } from '../../__styling/settings/metrics'
import { calcRem } from '../../__styling/style-functions/calc-rem'

export const StyledSourceLogo = styled('img')({
    marginRight: calcRem(8),
    width: calcRem(70),
})

export const StyledSourceFallback = styled('span')({
    whiteSpace: 'nowrap',
    padding: calcRem(metrics.sevennews.margins.sm),
})
